export const STEP_0_EMAIL = 'EMAIL';
export const STEP_0_PASSWORD = 'PASSWORD';
export const STEP_1_WEBSITE_CATEGORY = 'WEBSITE_CATEGORY';
export const STEP_1_FOOD_CATEGORY = 'FOOD_CATEGORY';
export const STEP_2_HOW_LONG = 'STEP_2_HOW_LONG';
export const STEP_3_GOOGLE_LOCATION = 'NAME_OF_THE_BUSINESS';
export const STEP_3_CUSTOM_LOCATION = 'ADDRESS_OF_THE_RESTAURANT';
export const STEP_4_MORE_LOCATIONS = 'MORE_LOCATIONS';
export const STEP_4_LOCATIONS_AMOUNT = 'LOCATIONS_AMOUNT';
export const STEP_5_LOGO = 'LOGO';
export const STEP_5_LOGO_UPLOAD = 'LOGO_UPLOAD';
export const STEP_6_MENUS = 'MENUS';
export const STEP_6_MENUS_UPLOAD = 'MENUS_UPLOAD';
export const STEP_7_INSTAGRAM = 'INSTAGRAM';
export const STEP_7_INSTAGRAM_ACCOUNT = 'INSTAGRAM_ACCOUNT';
export const STEP_7_INSTAGRAM_PROFILE = 'INSTAGRAM_PROFILE';
export const STEP_8_ACCEPT_RESERVATIONS = 'ACCEPT_RESERVATIONS';
export const STEP_8_HAVE_ERB = 'HAVE_ERB';
export const STEP_8_ERB_PROVIDER = 'ERB_PROVIDER';
export const STEP_9_PRIVATE_ROOMS = 'PRIVATE_ROOMS';
export const STEP_9_HAVE_BEO = 'HAVE_BEO';
export const STEP_9_BEO_PROVIDER = 'BEO_PROVIDER';
export const STEP_10_EVENTS = 'EVENTS';
export const STEP_11_DIGITAL_GC = 'DIGITAL_GC';
export const STEP_11_ALREADY_SELL = 'DIGITAL_GC_ALREADY_SELL';
export const STEP_11_URL = 'DIGITAL_GC_URL';
export const STEP_12_PHYSICAL_GC = 'PHYSICAL_GC';
export const STEP_12_ALREADY_SELL = 'PHYSICAL_GC_ALREADY_SELL';
export const STEP_12_URL = 'PHYSICAL_GC_URL';
export const ADDITIONAL_PRODUCTS = 'ADDITIONAL_PRODUCTS';
export const STEP_14_CATERING = 'CATERING';
export const STEP_14_CATERING_ORDERS = 'CATERING_ORDERS';
export const STEP_14_CATERING_MENU = 'CATERING_MENU';
export const STEP_15_ACCEPT_PICKUP = 'ACCEPT_PICKUP';
export const STEP_15_PICKUP_MENU = 'P_15_PICKUP_MENU';
export const STEP_16_ACCEPT_DELIVERY = 'ACCEPT_DELIVERY';
export const STEP_16_OWN_DRIVER = 'OWN_DRIVER';
export const STEP_17_DISPLAY_THIRD = 'DISPLAY_THIRD';
export const STEP_17_LIST = 'LIST';
export const STEP_18_HIRING = 'HIRING';
export const ACCOUNT_EMAIL = 'ACCOUNT_EMAIL';
export const ACCOUNT_PROMO = 'ACCOUNT_PROMO';
export const STRIPE_DETAILS = 'STRIPE_DETAILS';
export const CUSTOMER_NAME = 'CUSTOMER_NAME';
export const EXISTING_WEBSITE = 'EXISTING_WEBSITE';
export const EXISTING_WEBSITE_URL = 'EXISTING_WEBSITE_URL';
export const ONLINE_ORDERING = 'ONLINE_ORDERING';
export const ONLINE_ORDERING_SERVICES = 'ONLINE_ORDERING_SERVICES';

export const CUSTOM_PHOTOS = 'CUSTOM_PHOTOS';
export const CUSTOM_PHOTOS_UPLOAD = 'CUSTOM_PHOTOS_UPLOAD';

export const FOOD_SERVICE_PROVIDER = 'FOOD_SERVICE_PROVIDER';
export const FOOD_SERVICE_ACCOUNT = 'FOOD_SERVICE_ACCOUNT';
export const FOOD_SERVICE_SALES = 'FOOD_SERVICE_SALES';

export const PAYMENT_PLAN = 'PAYMENT_PLAN';
export const BRANDPOINTSPLUS_GIFTCARD = 'BRANDPOINTSPLUS_GIFTCARD';
export const CALENDLY_LINK = 'CALENDLY_LINK';
